export const ENV = (process.env["settings"] || {});
